import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-audio-disable',
  templateUrl: './audio-disable.component.html',
  styleUrls: ['./audio-disable.component.scss']
})
export class AudioDisableComponent implements OnInit {

  @Input() public message;
  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  closeDialog() {
    this.activeModal.close();
  }
}
